import { useQuery } from "@tanstack/react-query";
import { ProductService } from "../services/productService";
import {
  DashboardRange,
  DEFAULT_RANGE,
  rangeKey,
  rangeToParams,
} from "../types/dashboardRange";

const useStats = (range: DashboardRange = DEFAULT_RANGE) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['stats', rangeKey(range)],
        queryFn: () => ProductService.getStats(rangeToParams(range)),
    });

    return { data, isLoading, error };
};

export default useStats;
